export default __webpack_public_path__ + "static/media/download-google-play-badge-fr.9c0cb0dd.svg";